import { _ as _copyObject } from './_copyObject.mjs';
import { k as keys_1 } from './keys.mjs';

var copyObject = _copyObject,
    keys = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

var _baseAssign = baseAssign;

export { _baseAssign as _ };
